import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="relative flex items-center justify-center pt-20 pb-8 overflow-hidden" data-id="element-107">
      {/* Subtle Background Effects - contained to prevent CLS */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-108">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#00f0ff]/5 rounded-full blur-[120px] opacity-50 will-change-transform" data-id="element-109" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#8b5cf6]/5 rounded-full blur-[120px] opacity-50 will-change-transform" data-id="element-110" />
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:32px_32px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)] opacity-30" data-id="element-111" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center flex flex-col items-center" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="w-full" data-id="element-113">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#18181b] border border-[#27272a] text-gray-400 text-sm font-medium mb-4" data-id="element-114">
            <span className="flex h-2 w-2 rounded-full bg-[#00f0ff]" data-id="element-115"></span>
            El método definitivo revelado
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-[5rem] font-extrabold text-white leading-[1.1] tracking-tight mb-4" data-id="element-116">
            DOMINÁ EL ARTE DE LAS <br data-id="element-117" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] via-[#3b82f6] to-[#8b5cf6]" data-id="element-118">
              MESAS INFINITAS
            </span>
          </h1>

          {/* LCP image - using regular img for fetchPriority support */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mx-auto mb-6 w-80 md:w-[32rem] lg:w-[36rem]" data-id="element-119">
            <img src="https://cdn.magicpatterns.com/uploads/rHfathL2wpFVzeSwedqogt/Mockup_(1).webp" alt="Ebook Mesas y Espejos Infinitos" width={576} height={400} fetchPriority="high" loading="eager" decoding="sync" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,240,255,0.15)]" data-id="element-120" />
          </motion.div>

          <p className="text-xl md:text-2xl text-gray-400 mb-8 max-w-3xl mx-auto font-normal leading-relaxed" data-id="element-121">
            Dejá de improvisar y empezá a crear piezas de lujo que todos quieran
            comprar. La guía paso a paso para resultados profesionales.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-122">
            <motion.button whileHover={{
            scale: 1.02,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToPricing} className="bg-gradient-to-b from-[#f5c518] to-[#d97706] text-black font-extrabold text-xl md:text-2xl px-12 py-5 rounded-xl uppercase tracking-wide transition-all shadow-[0_8px_30px_rgba(245,197,24,0.25)] border border-[#f5c518]/50 w-full md:w-auto" data-id="element-123">
              QUIERO ACCEDER AHORA
            </motion.button>

            {/* Social Proof */}
            <div className="flex flex-col items-center gap-2 opacity-60" data-id="element-124">
              <div className="flex gap-1" aria-label="5 estrellas de calificación" data-id="element-125">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" aria-hidden="true" data-id="element-126" />)}
              </div>
              <p className="text-sm font-medium text-gray-300" data-id="element-127">
                +500 alumnos ya están creando sus mesas
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}